import React, { useState } from 'react'
import { Color } from 'constants/assets'
import { useGalleryAssignment, useGalleryDeal } from '../../contexts'

import { AnalyticsEvent } from 'utils/analytics'
import CircularProgress from '@mui/material/CircularProgress'
import { ClientGalleryOrderDetailDrawer } from '../ClientGalleryOrderDetailDrawer'
import { ClientGalleryPriceSummaryCard } from '../ClientGalleryPriceSummaryCard'
import { ClientGalleryUploadPowerAttorney } from '../ClientGalleryUploadPowerAttorney'
import { ClientOrderDetail } from 'components/common/Gallery/ClientOrderDetail'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'

export enum OrderInformationContext {
  GALLERY = 'GALLERY',
  PROPERTY = 'PROPERTY'
}

export interface Props {
  /** Whether the Information tab is within Gallery or Property*/
  context: OrderInformationContext
}

/**
 * @component Client Gallery Order Information tab content
 * @example <ClientGalleryOrderInformation />
 */
export const ClientGalleryOrderInformation: React.FC<Props> = ({ context = OrderInformationContext.GALLERY }) => {

  const { assignment, logGalleryEvent } = useGalleryAssignment()
  const { order, requiresPowerOfAttorneyDocuments } = useGalleryDeal()

  const isCardLoading = assignment.isPending || !!order?.isPending

  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true)

    logGalleryEvent(AnalyticsEvent.CLICK_ORDER_DETAILS)
  }

  return (
    <>

      {isCardLoading &&
        <Stack alignItems="center" justifyContent="center" sx={{ minHeight: '12rem', width: '100%' }}>
          <CircularProgress
            sx={{
              color: Color.GRAY_DISABLED,
            }}
          />
        </Stack>
      }

      {!isCardLoading && context === OrderInformationContext.GALLERY &&
        <Grid container spacing={2.5} alignItems="start" direction={{ xs: 'column', sm: 'row' }} paddingTop="2.3rem">

          <Grid item xs={12} md={4} width="100%">
            <ClientGalleryPriceSummaryCard />
          </Grid>

          <Grid item xs={12} md={8} width="100%">

            <ClientOrderDetail onOpenDrawer={handleOpenDrawer} />

            {requiresPowerOfAttorneyDocuments &&
              <ClientGalleryUploadPowerAttorney />
            }

          </Grid>
        </Grid>
      }

      {!isCardLoading && context === OrderInformationContext.PROPERTY &&
        <Stack marginBottom={2.4}>
          <ClientOrderDetail onOpenDrawer={handleOpenDrawer}>
            {requiresPowerOfAttorneyDocuments &&
              <ClientGalleryUploadPowerAttorney />
            }
          </ClientOrderDetail>

        </Stack>
      }

      <ClientGalleryOrderDetailDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
    </>
  )
}
